import React from 'react';
import { Modal } from 'antd';
import OrderList from './OrderList';

const OrdersModal = ({ showModal, setShowModal, driver }) => {

  return (
    <Modal
      title="Предложить груз"
      closable={{ 'aria-label': 'Custom Close Button' }}
      open={showModal}
      footer={null}
      width="95vw"
      height="90vh"
      onCancel={() => setShowModal(false)}
    >
      {showModal && <OrderList showModal={showModal} driver={driver} setShowModal={setShowModal} />}
    </Modal>
  );
};

export default OrdersModal;
